import { Vertical } from 'component/Vertical'
import { env } from 'config/environment'
import i18next from 'i18next'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { DemoCatalogData } from 'type/demo'
import { formatQuery } from 'util/query'
import css from './LoginStep.module.scss'

function buildBase(data: DemoCatalogData): Record<string, any> {
  const { product } = data
  const lang = i18next.language
  const back = location.pathname + location.search
  const company = product.company_id
  const tsum = product.tsumDesign ? '' : null
  return { lang, back, company, tsum }
}

function buildFallback(data: DemoCatalogData) {
  const base = buildBase(data)
  const query = formatQuery({ ...base, auth0: true })
  return `${location.origin}/boutique/login${query}`
}

function buildAuth(data: DemoCatalogData) {
  const redirect = `${location.origin}/boutique/auth`
  const fallback = buildFallback(data)
  const base = buildBase(data)
  const query = formatQuery({ ...base, redirect, fallback })
  return `${env.auth_url}/login${query}`
}

export const LoginStep = observer(() => {
  const { data } = useDemo()
  const src = env.auth_url ? buildAuth(data) : buildFallback(data)

  return <Vertical>
    <iframe className={css.frame} src={src} />
  </Vertical>
})
